// Sync cache for the selected tenant's realm URL.
// Written by TenantProvider on tenant selection, read by legacy request.ts.
// Prefer useTenant() hook for reactive access in React components.

let cachedRealm: string | null = null;

export function getSelectedTenantRealm(): string | null {
  return cachedRealm;
}

export function setSelectedTenantRealm(realm: string | null): void {
  cachedRealm = realm;
}
